import { AddProductToCartModel } from '@api/models/add-product-to-cart-model';
import { UpdateCartLineQuantityModel } from '@api/models/update-cart-line-quantity-model';
import { CartLine } from '@api/models/cart-line';
import { Response } from '@api/models/response';
import { CalculateVatModel } from '@api/models/calculate-vat-model';

export class LoadCart {
  static readonly type = '[Cart] LoadCart';
  constructor(public commitPosition?: number) {}
}

export class AddProductToCart {
  static readonly type = '[Cart] AddProductToCart';
  constructor(public payload: AddProductToCartModel) {}
}

export class AddProductsToCart {
  static readonly type = '[Cart] AddProductsToCart';
  constructor(public payloads: AddProductToCartModel[]) {}
}

export class CartActionSuccess {
  static readonly type = '[Cart] CartActionSuccess';
  constructor(public payload: Response) {}
}

export class UpdateCartLineQuantity {
  static readonly type = '[Cart] UpdateCartLineQuantity';
  constructor(public payload: UpdateCartLineQuantityModel) {}
}

export class DeleteCartLine {
  static readonly type = '[Cart] DeleteCartLine';
  constructor(public payload: CartLine) {}
}

export class DeleteCart {
  static readonly type = '[Cart] DeleteCart';
}

export class ClearWarnings {
  static readonly type = '[Cart] ClearWarnings';
}

export class ApplyCoupon {
  static readonly type = '[Cart] ApplyCoupon';
  constructor(public payload: string) {}
}

export class ApplyCouponError {
  static readonly type = '[Cart] ApplyCouponError';
  constructor(public payload: string) {}
}

export class DetachCoupon {
  static readonly type = '[Cart] DetachCoupon';
  constructor(public payload: string) {}
}

export class ResetCouponError {
  static readonly type = '[Cart] ResetCouponError';
}

export class CalculateVat {
  static readonly type = '[Cart] CalculateVat';

  constructor(public payload: CalculateVatModel) {}
}
